import PropTypes from 'prop-types';

const searchFilterPropType = PropTypes.shape({
  facetId: PropTypes.number,
  operatorId: PropTypes.number,
  value1: PropTypes.string,
  value2: PropTypes.string,
});

export default { searchFilterPropType };
